<template>
  <v-layout nowrap align-center justify-space-between style="width: 100%">
    <v-flex xs2 sm1>
      <v-text-field
        solo-inverted
        flat
        hide-details
        class="mx-1 elevation-0"
        :value="order"
        :disabled="disabled"
        @change="updateOrder"
      ></v-text-field>
    </v-flex>
    <v-flex xs5 sm3>
      <v-text-field
        solo
        flat
        hide-details
        :value="ingredient.nom"
        readonly
      ></v-text-field>
    </v-flex>
    <v-flex xs5 sm3>
      <v-text-field
        class="mx-1"
        solo-inverted
        flat
        hide-details
        :value="quantity"
        @change="updateQuantity"
        :disabled="disabled"
        :suffix="ingredient.unite_mesure"
      ></v-text-field>
    </v-flex>
    <v-flex xs5 sm2>
      <v-text-field
        class="mx-1"
        solo
        flat
        hide-details
        :value="ingredient.prix"
        prefix="x"
        suffix="$"
        readonly
      ></v-text-field>
    </v-flex>
    <v-flex xs5 sm2>
      <v-text-field
        class="mx-1"
        solo
        flat
        hide-details
        :value="ingredient.cost"
        prefix="="
        suffix="$"
        readonly
      ></v-text-field>
    </v-flex>
    <v-flex shrink>
      <v-btn class="ma-0 pa-0" icon small @click="$emit('remove')">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import { mappers } from "@/mappers";
export default {
  name: "IngredientListTile",
  props: {
    id: {
      required: true
    },
    order: {
      required: true
    },
    quantity: {
      required: true
    },
    ingredient: {
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getProducts"])
  },
  methods: {
    updateOrder(value) {
      this.$emit("update:order", value);
      this.$emit("change");
    },
    updateQuantity(value) {
      const product = this.getProducts.find(
        x => x.id === this.ingredient.pk_recette_produit
      );
      if (product && product.data.use_alternative_unit === true) {
        let is_alternative_unite_mesure = false;
        let alt_unit_possibilities = [];
        if (
          !mappers.isCustomUnit(
            product.data.alternative_unite_mesure_production
          )
        ) {
          alt_unit_possibilities = this.$units()
            .from(product.data.alternative_unite_mesure_production)
            .possibilities()
            .filter(x => this.getAllowedUnits.includes(x));
        } else {
          alt_unit_possibilities = this.getCustomUnits;
        }
        is_alternative_unite_mesure = alt_unit_possibilities.includes(
          this.ingredient.unite_mesure
        );
        this.$emit(
          "update:is_alternative_unite_mesure",
          is_alternative_unite_mesure
        );
      }
      this.$emit("update:quantity", value);
      this.$emit("change");
    }
  }
};
</script>

<style lang="scss" scoped></style>
